import { render } from "./Transaction.vue?vue&type=template&id=47a3ba3f&scoped=true"
import script from "./Transaction.vue?vue&type=script&lang=js"
export * from "./Transaction.vue?vue&type=script&lang=js"

import "./Transaction.vue?vue&type=style&index=0&id=47a3ba3f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-47a3ba3f"

export default script